import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";

const getOptions = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.cashier_report.options;

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(data => data)
    .catch(error => error);
};

const getCashiers = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.cashier_report.cashiers;
  const payload = { ...data, authenticity_token };

  return fetch(endpoint, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(data => data)
    .catch(error => error);
};

const getCurrencies = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.cashier_report.currencies;
  const payload = { ...data, authenticity_token };

  return fetch(endpoint, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(data => data)
    .catch(error => error);
};

const getBrands = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.cashier_report.brands;
  const payload = { ...data, authenticity_token };

  return fetch(endpoint, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(data => data)
    .catch(error => error);
};

const getPlatforms = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.cashier_report.platforms;
  const payload = { ...data, authenticity_token };

  return fetch(endpoint, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(data => data)
    .catch(error => error);
};

const getReport = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.cashier_report.generate_report;
  const sendData = { ...data.payload, authenticity_token };

  return fetch(endpoint, {...RequestOptions('POST', JSON.stringify(sendData))})
    .then(handleResponse)
    .then(data => data)
    .catch(error => error);
};

const setDownload = (data: any) => {
  const authenticity_token = getCookie(cookieToken);
  const endpoint = api.admin.cashier_report.download_report;
  const payload = { ...data.payload, authenticity_token };

  return fetch(endpoint, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(data => data)
    .catch(error => error);
};

export const agentStatisticReportService = {
  getOptions,
  getReport,
  getCashiers,
  getCurrencies,
  getBrands,
  getPlatforms,
  setDownload,
};
